import {
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAIL,
  UPDATE_SETTING_SUCCESS,
  UPDATE_SETTING_FAIL,
  UPDATE_SETTING
  
} from "./actionTypes";

const INIT_STATE = {
  settings: {},
  settingProfile: {},
  error: {},
  loading:false
};

const settings = (state = INIT_STATE, action) => {
  // console.log(action)
  let payload = action.payload
  switch (action.type) {
    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.payload.data,
      }

    case GET_SETTINGS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

      case UPDATE_SETTING:
        return {
          ...state,
          loading:true
        }
    case UPDATE_SETTING_SUCCESS:
      
      return {
        ...state,
        payload,
        loading: false,
      }

    case UPDATE_SETTING_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }

    default:
      return state
  }
};

export default settings;
